import * as actions from '../../actions/search';

import { initialState } from './initialState';

export { initialState };

export const searchState = (state = initialState, action) => {
	switch (action.type) {
		case actions.SEARCH_LOADED:
			return { ...state, results: action.payload };
		case actions.SEARCH_COMPETENCY_LOADED:
			return { ...state, competency: action.payload };
		case actions.SEARCH_LOADING:
			return { ...state, loading: action.payload };
		case actions.SEARCH_ERROR:
			return { ...state, error: action.payload };
		default:
			return state;
	}
};
